import { render, staticRenderFns } from "./IconCoinMinus.vue?vue&type=template&id=3bfb31a5&scoped=true&"
import script from "./IconCoinMinus.vue?vue&type=script&lang=js&"
export * from "./IconCoinMinus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfb31a5",
  null
  
)

export default component.exports